import globalMethods from "@/globalMethods";
import {URLS} from "@/constants";
import {notify} from "@/plugins/notification";
import i18n from "@/i18n";


export default {
    namespaced: true,
    state: {
        tasks: [],
    },
    mutations: {
        setTasks(state, newTasks) {
            state.tasks = newTasks;
        },
        updateTask(state, data) {
            const taskIndex = state.tasks.findIndex(task => task.id === data.id);
            state.tasks[taskIndex] = data;
        },
        addTask(state, newTask) {
            state.tasks.unshift(newTask);
        },
    },
    actions: {
        async getTasks({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {dateFrom, dateTo} = params;
            const url = `${URLS.MODEL.TASK.TASKS_URL}?date-from=${dateFrom}&date-to=${dateTo}`;
            const options = {
                method: "GET",
                headers: {
                    role: personalData.role,
                    companyId: company.companyData?.token,
                    shopId: globalMethods.getDataFromLocalStorage("currentCashRegisterId"),
                },
                credentials: 'include',
            };
            const successfulHandler = (data) => {
                commit("setTasks", data.data);
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async completeTask({commit, rootState}, params) {
            const {personalData, company} = rootState;
            const {taskID} = params;
            const url = URLS.MODEL.TASK.TASK_URL.replace("<ID>", taskID);
            const options = {
                method: "POST",
                headers: {
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                    shopId: globalMethods.getDataFromLocalStorage("currentCashRegisterId"),
                },
                credentials: 'include',
            };
            const successfulHandler = (data) => {
                commit("updateTask", data.data);
                notify(i18n.global.t("Task completed successfully"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
        async createTask({commit, rootState}, params) {
            const {personalData, company, cashRegister} = rootState;
            const {content} = params;
            const url = URLS.MODEL.TASK.TASKS_URL;
            const options = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                    shopId: globalMethods.getDataFromLocalStorage("currentCashRegisterId"),
                    timezone: cashRegister.cashRegisterData?.timezone,
                },
                body: JSON.stringify({
                    content: content,
                }),
                credentials: 'include',
            };
            const successfulHandler = (data) => {
                commit("addTask", data.data);
                notify(i18n.global.t("New task successfully created"));
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options, successfulHandler: successfulHandler});
        },
    },
};